import React from "react";
import authRoutes from "../modules/auth/routes";
import { renderRoutes } from "react-router-config"

import menuRoutes from "../modules/menu/routes"
import SecurityLayout from "../layouts/SecurityLayout"
import { BrowserRouter, HashRouter } from "react-router-dom";
import ordersRoutes from "../modules/stats/routes";
import clientsRoutes from "../modules/clients/routes";

import documentsRoutes from "../modules/documents/routes";

export const config = [
    authRoutes,
    {
        id: "common",
        path: "/",
        name: "Общие",
        hide: false,
        component: SecurityLayout,
        routes: [
           ...ordersRoutes,
            ...clientsRoutes,
            ...menuRoutes,
            ...documentsRoutes,
            /*...branchesRoutes,*/
        ]
    }
];


function WebRouterConfig() {
    return (
            <BrowserRouter>
                {renderRoutes(config)}
            </BrowserRouter>

    );
}

function CordovaRouterConfig() {
    return (
            <HashRouter basename='/'>
                {renderRoutes(config)}
            </HashRouter>

    );
}

function getRouterConfig(){
    if(process.env.REACT_APP_BUILD_MODE === "CORDOVA"){
        return CordovaRouterConfig
    }else if(process.env.REACT_APP_BUILD_MODE === "WEB"){
        return WebRouterConfig
    }else{
        throw `Unknown REACT_APP_BUILD_MODE. Expected 'CORDOVA' or 'WEB' but got ${process.env.BUILD_MODE}`
    }

}

export default getRouterConfig();
